import { session } from '@farmersdog/utils';

export const CHECKED_OUT_WITH_MIXING_KEY = 'checked-out-with-mixing-plan';

function get(): string | null {
  return session.getItem(CHECKED_OUT_WITH_MIXING_KEY);
}

function set(state: 'true'): void {
  session.setItem(CHECKED_OUT_WITH_MIXING_KEY, state);
}

export const checkedOutWithMixingPlan = {
  get,
  set,
};
